module.exports = __webpack_public_path__ + "static/media/notesActive.7781e188.svg";